import { useState } from 'react';
import { emailProfile } from 'api';
import { AnonymisationType } from 'types/types';
import { AllDialectOptions } from 'types/dialects';

type UseProfileEmailProps = {
  learnerId: string;
  profileId: string;
  downloadDialect: Exclude<AllDialectOptions, 'evaluation-dialect'>;
  anonymisationType?: AnonymisationType;
  onEmailError?: () => void;
};

export const useProfileEmail = ({
  profileId,
  downloadDialect,
  anonymisationType,
  onEmailError,
}: UseProfileEmailProps) => {
  const [showEmailProgress, setShowEmailProgress] = useState(false);
  const [showDistOptions, setShowDistOptions] = useState(false);

  const handleSendEmail = async (format?: string) => {
    try {
      await emailProfile(profileId, downloadDialect, format, anonymisationType);
      setShowDistOptions(false);
      setShowEmailProgress(true);
    } catch {
      onEmailError?.();
    }
  };

  const onEmailProfile = () => {
    setShowDistOptions(true);
  };

  const onExploreEmailProfile = async (format?: string) => {
    try {
      await emailProfile(profileId, downloadDialect, format);
      setShowEmailProgress(true);
    } catch {
      onEmailError?.();
    }
  };

  return {
    onEmailProfile,
    handleSendEmail,
    onExploreEmailProfile,
    showEmailProgress,
    setShowEmailProgress,
    showDistOptions,
    setShowDistOptions,
  };
};
